import { FC } from 'react'
import Typography from '@components/typography'
import Row from '@components/row'
import Column from '@components/column'
interface AuthHeaderProps {
  content?: string
  tag?: string
  subContent?: string
}
const AuthHeader: FC<AuthHeaderProps> = ({ content, tag, subContent }) => {
  return (
    <Column>
      <Row justifyContent="center" colGap={5}>
        <Typography size={24} variant="h3">
          {content}
        </Typography>

        <Typography size={24} variant="h3" tc="primary">
          {tag}
        </Typography>
      </Row>
      {!!subContent && (
        <Row justifyContent="center" styleRow="margin-top:5px">
          <Typography size={14} tc="primary100">
            {subContent}
          </Typography>
        </Row>
      )}
    </Column>
  )
}

export default AuthHeader
